export type TelemetryProvenance = 'live' | 'demo' | 'unavailable'

export function hasTelemetryReading(data: unknown): boolean {
  if (!Array.isArray(data)) return false
  return data.some(item => {
    if (!item || typeof item !== 'object') return false
    const record = item as Record<string, unknown>
    return ['temp_c', 'power_w'].some(key => {
      const value = record[key]
      return value !== null && value !== undefined && Number.isFinite(Number(value))
    })
  })
}

export function telemetryProvenance(data: unknown, demoMode: boolean): TelemetryProvenance {
  if (demoMode) return 'demo'
  return hasTelemetryReading(data) ? 'live' : 'unavailable'
}
